var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "stlLookStack",
      class: {
        "is-stack": _vm.isStack,
        "is-cycling": _vm.isCycling,
        "is-cycle-active": _vm.isCycleActive,
      },
      on: {
        mouseenter: _vm.pauseCycle,
        mouseleave: _vm.resumeCycle,
        focusin: _vm.pauseCycle,
        focusout: _vm.resumeCycle,
      },
    },
    [
      _c(
        "div",
        { staticClass: "stlLookStackFrame" },
        [
          _vm.isStack
            ? _c(
                "div",
                {
                  staticClass: "stlLookStackLayers",
                  attrs: { "aria-hidden": "true" },
                },
                _vm._l(_vm.stackLayers, function (layer) {
                  return _c("img", {
                    key: layer.id,
                    staticClass: "stlLookStackLayerImage",
                    attrs: { src: layer.imageUrl, alt: "", loading: "lazy" },
                  })
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("shop-the-look-item", {
            staticClass: "stlLookStackTop stlLookStackBase",
            attrs: { config: _vm.activeLook },
            on: { "open-fullscreen": _vm.emitOpenFullscreen },
          }),
          _vm._v(" "),
          _vm.isCycling
            ? _c(
                "div",
                {
                  staticClass: "stlLookStackTransition",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _vm.cycleCurrentLook
                    ? _c(
                        "picture",
                        {
                          staticClass:
                            "stlLookStackTransitionPicture stlLookStackCurrentImage",
                        },
                        [
                          _vm.cycleCurrentLook.imageUrlMobile
                            ? _c("source", {
                                attrs: {
                                  media: "(max-width: 576px)",
                                  srcset: _vm.cycleCurrentLook.imageUrlMobile,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: _vm.cycleCurrentLook.imageUrl,
                              alt: "",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.incomingLook
                    ? _c(
                        "picture",
                        {
                          staticClass:
                            "stlLookStackTransitionPicture stlLookStackIncomingImage",
                        },
                        [
                          _vm.incomingLook.imageUrlMobile
                            ? _c("source", {
                                attrs: {
                                  media: "(max-width: 576px)",
                                  srcset: _vm.incomingLook.imageUrlMobile,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            attrs: { src: _vm.incomingLook.imageUrl, alt: "" },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isStack
            ? _c(
                "button",
                {
                  staticClass: "stlLookStackCount",
                  attrs: {
                    type: "button",
                    "aria-label": `Look mit ${_vm.variants.length} Varianten vergroessern`,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.emitOpenFullscreen.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      +" + _vm._s(_vm.variants.length - 1) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("span", {
        staticClass: "caption",
        domProps: { innerHTML: _vm._s(_vm.activeTitle) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }